import React from "react";

export default function Marquee({ items }) {
    const seg = (hidden) => (
        <div className="marquee-seg flex flex-0-0-auto items-center" aria-hidden={hidden || undefined}>
            {items.map((item, i) => (
                <span key={`${hidden}-${i}`} className="flex items-center">
                    <span className="font-display font-semibold tracking-[0.3em] text-sm sm:text-base text-forest-800 px-8">
                        {item}
                    </span>
                    <svg width="14" height="14" viewBox="0 0 24 24" className="text-forest-400" fill="currentColor" aria-hidden="true">
                        <path d="M12 2C9 7 6 10 2 12c4 2 7 5 10 10 3-5 6-8 10-10-4-2-7-5-10-10z" />
                    </svg>
                </span>
            ))}
        </div>
    );
    return (
        <div className="marquee-wrap bg-mint border-y border-forest-100 py-4 select-none" data-testid="services-marquee">
            <div className="marquee-track">
                {seg(false)}
                {seg(true)}
            </div>
        </div>
    );
}